import { toast } from 'react-toastify';
function toastSuccess(message, timeout) {
    toast.error(message, {
        position: 'top-center',
        autoClose: timeout ? timeout : false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        className: 'toast-base toast-success',
    });
}
export default toastSuccess;
